import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function ArticleNavbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70" : "bg-background-50 border-b border-background-200/40"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="w-8 h-8 flex items-center justify-center">
              <i className="ri-arrow-left-line text-lg text-foreground-700"></i>
            </span>
            <span className="font-heading text-lg font-bold text-primary-600">
              itaobuy<span className="text-accent-500">.team</span>
            </span>
          </Link>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-5 py-2 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>
      </div>
    </nav>
  );
}